
/**
 * Get the backend API URL based on environment
 * - Local dev (npm run dev): http://localhost:3001
 * - Docker/Production: /api (proxied by nginx)
 */
export function getApiUrl(): string {
  // Explicit override for testing or special cases
  if (process.env.REACT_APP_TERRIAMAP_URL) {
    return process.env.REACT_APP_TERRIAMAP_URL;
  }

  // Production / Docker / Azure: use relative /api path
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }

  // Development: full localhost URL (without /api)
  return 'http://localhost:3001';
}

/**
 * Get full API endpoint URL
 * Adds /api prefix automatically
 */
export function getApiEndpoint(path: string): string {
  const baseUrl = getApiUrl();
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  if (baseUrl.startsWith('/')) {
    const url = `${baseUrl}/${cleanPath}`;
    console.log(`[API DEBUG] ${cleanPath} → ${url}`);
    return url;
  }

  const url = `${baseUrl}/api/${cleanPath}`;
  console.log(`[API DEBUG] ${cleanPath} → ${url}`);
  return url;
}